import { useContext } from "react";
import { MachineSetupContextLoading } from "./MachineSetupContextProvider";

const useMachineSetupContextLoading = () => {
   const context = useContext(MachineSetupContextLoading);
   if (context === undefined) {
      throw new Error("useMachineSetupContextLoading was used outside of it's provider");
   }
   return context;
}

export { useMachineSetupContextLoading };
